import React from "react";
import {useSelector} from "react-redux";
import NumberFormat from "react-number-format";
import numeral from "numeral";
import {Field, useFormikContext} from "formik";
import {Checkbox, FormControlLabel, Grid, Typography} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import {Label} from "../../../components/formInputs";
import {ErrorHelper, NumberTextField, TextField} from "../../../components/formikFormInputs";
import TextFieldCommon from "../../formikFormInputs/TextFieldCommon";
import {RootState} from "../../../reducers";
import {AccountType} from "../../../constants";


export const liabilitiesFields = [
    {
        id: "unpaidInterestTaxes",
        name: "unpaidInterestTaxes",
        helperFieldText: "",
        label: <Label label={"Taxes and Interest Due"} required={false}/>,
        // label: <Label label={"Unpaid Interest & Taxes" } required={false}/>,
        isRequired: true,
        className: "mt10",
        filedType: "string",
        component: NumberTextField,
        InputProps: {
            startAdornment: <InputAdornment disableTypography={true}
                                            position="start">$</InputAdornment>,
        },
        variant: "outlined",
    },
    {
        id: "mortgages",
        name: "mortgages",
        helperFieldText: "",
        // label: <Label label={"Real Estate Mortgages or Liens"} required={false}/>,
        label: <Label label={"Real Estate Mortgages or Liens"} required={false}/>,
        isRequired: false,
        className: "mt10",
        filedType: "string",
        component: NumberTextField,
        InputProps: {
            startAdornment: <InputAdornment disableTypography={true}
                                            position="start">$</InputAdornment>,
        },
        variant: "outlined",
    },
    {
        id: "loansOnLifeInsurance",
        name: "loansOnLifeInsurance",
        // label: <Label label={"Loans on Life Insurance"} required={false}/>,
        label: <Label label={"Loans on Life Insurance"} required={false}/>,
        component: NumberTextField,
        InputProps: {
            startAdornment: <InputAdornment disableTypography={true}
                                            position="start">$</InputAdornment>,
        },
    },
    {
        id: "personalNotes",
        name: "personalNotes",
        // label: <Label label={""} required={false}/>,
        label: <Label label={"Notes Payable"} required={false}/>,
        component: NumberTextField,
        InputProps: {
            startAdornment: <InputAdornment disableTypography={true}
                                            position="start">$</InputAdornment>,
        },
    },
    {
        id: "accountsPayable",
        name: "accountsPayable",
        label: <Label label={"Accounts Payable"} required={false}/>,
        // label: <Label label={ isIliaApp(offerType) ? "Personal Notes" : "Accounts Payable" } required={false}/>,
        component: NumberTextField,
        InputProps: {
            startAdornment: <InputAdornment disableTypography={true}
                                            position="start">$</InputAdornment>,
        },
    },
    {
        id: "otherLiabilities",
        name: "otherLiabilities",
        label: <Label label={"Other Liabilities Amount"} required={false}/>,
        component: NumberTextField,
        InputProps: {
            startAdornment: <InputAdornment disableTypography={true}
                                            position="start">$</InputAdornment>,
        },
    },
    {
        id: "otherLiabilitiesDetails",
        name: "otherLiabilitiesDetails",
        label: <Label label={"Other Liabilities Details"} required={false}/>,
        component: TextField,

    },
];
const Liabilities = () => {
    const {values, handleChange, errors}: any = useFormikContext();
    const {user} = useSelector((state: RootState) => state.auth);
    const role = user && user.role;
    const [totalValues, setTotalValues] = React.useState<number>(0);

    React.useEffect(() => {
        let total = 0;

        liabilitiesFields.forEach((f) => {
            if (f.name === "otherLiabilitiesDetails") {
                return;
            }
            const value = values[f.name];
            total += numeral(value).value() || 0;
        });

        setTotalValues(total);
    }, [values]);

    return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography component="strong" variant="subtitle1"
                                className="floatLeft w100 mb10">
                        Giftor Liabilities
                        {
                                (role === AccountType.Multilife || role === AccountType.Individual) &&
                                <span className="floatRight">
                                    Total Liabilities:
                                    <NumberFormat
                                            value={totalValues || 0}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                            prefix={"$"}
                                    />
                                </span>
                        }
                    </Typography>
                    <Typography variant="body1" className="floatLeft w100 mb20">
                        Fill out or verify any giftor liabilities below.
                        If a particular field doesn't apply you can leave it blank.
                    </Typography>
                </Grid>
                {
                    liabilitiesFields.filter(x => !!x).map((field: any, index: number) => {
                        return (
                                <React.Fragment key={index}>
                                    {
                                            !!field.name &&
                                            <Grid item xs={12} sm={6} md={4}>
                                                <TextFieldCommon
                                                        {...field}
                                                        fullWidth
                                                        onChange={handleChange}
                                                        values={values}
                                                />
                                                <ErrorHelper errors={errors} name={field.name}/>
                                            </Grid>
                                    }
                                    {
                                            !field.name && field
                                    }

                                </React.Fragment>
                        );
                    })
                }
                <Grid item xs={12}>
                    {(role === AccountType.Multilife || role === AccountType.Individual) &&
                            <Field name="verifyLiabilities">
                                {({field}) => (
                                        <>
                                            <FormControlLabel
                                                    className="mb0"
                                                    control={
                                                        <Checkbox
                                                                {...field}
                                                                checked={field.value}
                                                                color="primary"
                                                                className="pt0 pl15 pb0"
                                                        />
                                                    }
                                                    label={
                                                        <Typography variant="caption">
                                                            I verify that my total Liabilities are &nbsp;
                                                            <NumberFormat
                                                                    value={totalValues || 0}
                                                                    displayType={"text"}
                                                                    thousandSeparator={true}
                                                                    prefix={"$"}
                                                            />
                                                            .<span className="requiredHighlight">*</span>
                                                        </Typography>
                                                    }
                                            />
                                            <ErrorHelper errors={errors} name={field.name}/>
                                        </>
                                )}
                            </Field>

                    }
                </Grid>
            </Grid>
    );
};

export default Liabilities;